import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const ADVISOR_FILTERS = new Set([
  'all',
  'wizard',
  'activeAccess',
  'withoutActiveAccess',
  'pendingSetup',
  'newInPeriod',
  'activeInPeriod',
  'inactiveInPeriod',
]);
const SUBSCRIPTION_FILTERS = new Set([
  'all',
  'active',
  'trialing',
  'canceled',
  'otherInactive',
  'inactive',
  'cancellationsWeekly',
  'cancellationsMonthly',
  'cancellationsInPeriod',
]);
const USAGE_FILTERS = new Set(
  [...ADVISOR_FILTERS, ...SUBSCRIPTION_FILTERS].filter(filter => filter !== 'wizard'),
);

export function useMetricFilterParams(activeTab: string): {
  filter: string | null;
  usageFilter: string | null;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawFilter = searchParams.get('filter');
  const rawUsageFilter = searchParams.get('usageFilter');
  const filterSet = activeTab === 'advisors' ? ADVISOR_FILTERS : SUBSCRIPTION_FILTERS;
  const filter = !rawFilter || filterSet.has(rawFilter) ? rawFilter : null;
  const usageFilter = !rawUsageFilter || USAGE_FILTERS.has(rawUsageFilter) ? rawUsageFilter : null;
  const hasStaleFilter =
    ((activeTab === 'advisors' || activeTab === 'subscriptions') &&
      rawFilter !== null &&
      filter === null) ||
    (activeTab === 'usage' && rawUsageFilter !== null && usageFilter === null);

  useEffect(() => {
    if (!hasStaleFilter) return;

    const nextParams = new URLSearchParams(searchParams);
    if (activeTab === 'usage') {
      nextParams.delete('usageFilter');
    } else {
      nextParams.delete('filter');
      nextParams.delete('from');
      nextParams.delete('to');
    }
    setSearchParams(nextParams, { replace: true });
  }, [activeTab, hasStaleFilter, searchParams, setSearchParams]);

  return { filter, usageFilter };
}
